'use client';
import ErrorContainer from '@/containers/ErrorContainer';
import EmptyLayout from '@/layouts/EmptyLayout';
import NextErrorProps from '@/types/next-error-props.type';

export default function GlobalError({ ...props }: NextErrorProps) {
  return (
    <EmptyLayout>
      <ErrorContainer {...props} />
    </EmptyLayout>
  );
}
